import React from 'react'
import style from './style.less'
import classNames from 'classnames'
import Typography, {
  TypographySizes,
  TypographyTypes,
} from '../Typography/Typography'
import Icon from '../Icon'

export interface ChipProps {
  disabled?: boolean
  selected?: boolean
  removable?: boolean
  negative?: boolean
  onClick: (event: React.MouseEvent<HTMLElement>) => void
  text: string | React.ReactNode
}

const Chip: React.FunctionComponent<ChipProps> = ({
  text,
  onClick,
  disabled = false,
  selected = false,
  removable = false,
  negative = false,
}) => (
  <button
    disabled={disabled}
    className={classNames(
      style.chip,
      selected ? style.chipSelected : undefined,
      removable ? style.chipRemovable : undefined,
      negative ? style.chipNegative : undefined
    )}
    data-testid={'chip'}
    onClick={onClick}
  >
    <>
      {selected && <Icon name={'Check'} dataTestId={'selectedIcon'} />}
      <Typography type={TypographyTypes.label} size={TypographySizes.large}>
        {text}
      </Typography>
      {removable && <Icon name={'Close'} />}
    </>
  </button>
)

export default Chip
